import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * トークルームの未読メッセージ数を取得
 *
 * 自分が所属しているチャットルームの未読数一覧を返す
 */
export class FetchUnread implements APIRequest<Monitaro.FetchUnreadResponse> {
  response: Monitaro.FetchUnreadResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = `/reads`
  }
}

/**
 * トークルームのメッセージを全て既読処理する
 *
 * チャットのトークを既読にする
 */
export class PutReadRoom implements APIRequest<Monitaro.PutReadRoomResponse> {
  response: Monitaro.PutReadRoomResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  constructor(room: string) {
    this.path = `/reads/rooms/${room}`
  }
}

/**
 * チャットトークの既読
 *
 * チャットのトークを既読にする
 */
export class PutReadTalk implements APIRequest<Monitaro.PutReadTalkResponse> {
  response: Monitaro.PutReadTalkResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  constructor(talk: string) {
    this.path = `/reads/talk/${talk}`
  }
}
